module.exports = __webpack_public_path__ + "img/MOA_logo.99cc5c8f.png";